import {Injectable} from '@angular/core';
import {MedicalRecordVisitReasonModel} from '../../api/model/medicalRecordVisitReason.model';
import {AbstractDeleteOneService} from '../../../../../core/service/v2/service/delete/abstractDeleteOne.service';
import {MedicalRecordVisitReasonRepository} from './ngrx/medicalRecordVisitReason.repository';
import {MedicalRecordVisitReasonDataServiceAdapter} from './ngrx/medicalRecordVisitReasonDataService.adapter';

@Injectable()
export class MedicalRecordVisitReasonDeleteService extends
    AbstractDeleteOneService<MedicalRecordVisitReasonModel, MedicalRecordVisitReasonModel> {

    constructor(public repository: MedicalRecordVisitReasonRepository,
                public dataServiceAdapter: MedicalRecordVisitReasonDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}